<template>
	<section class="courses-thumbnail-section courses-thumbnail-section--wishes">
		<h2 class="courses-thumbnail-section__title">{{  $t('wish_courses') }}</h2>
		<template v-if="selection.length">
			<ul class="courses-thumbnail-section__list">
				<li v-for="course in selection">
					<article class="course-thumbnail course-thumbnail--wishes">
						<a :href="'/courses/' + course.id" class="course-thumbnail__link" :title="course.name">
							<h3 class="course-thumbnail__title">{{ course.name }}</h3>
							<div class="course-thumbnail__arrow"></div>
						</a>
					</article>
				</li>
			</ul>
			<div class="courses-thumbnail-section__bottom">
				<a href="/my_learning_plan" class="app-btn app-btn--round app-btn--primary app-btn--arrow-up">{{ $t('buttons.go_to_wishes') }}</a>
			</div>
		</template>
		<template v-else>
			<div class="courses-thumbnail-section__message-holder">
				<p class="courses-thumbnail-section__message">
					{{ $t('messages.no_wished_plan') }}
				</p>
			</div>
		</template>
	</section>
</template>

<script>
export default {
	name: "MyWishesCourses",

	props: {
		selection: Array
	},

	data() {
		return {

		};
	},

	methods: {

	}
};
</script>
